<div (click)="handleSelectClick($event)" class="ng-control"
     [class.empty]="selectedItems.length === 0">

    <div class="ng-value-container">
        <div class="ng-placeholder" [hidden]="!showPlaceholder()">{{placeholder}}</div>
        <ng-template #defaultLabelTemplate let-item="item">
            <div class="ng-value-wrapper default" [class.disabled]="item.disabled">
                <span class="ng-value-label">{{item[bindLabel]}}</span>
                <span class="ng-value-icon" (click)="unselect(item); $event.stopPropagation()"
                      aria-hidden="true"><i class="icon-cross-circle"></i></span>
            </div>
        </ng-template>

        <div class="ng-value" *ngFor="let item of selectedItems">
            <ng-template
                [ngTemplateOutlet]="labelTemplate || defaultLabelTemplate"
                [ngTemplateOutletContext]="{ item: item, clear: clearItem }">
            </ng-template>
        </div>

        <div *ngIf="showFilter()" class="ng-input">
            <input #filterInput autocomplete="undefined"
                   [value]="filterValue" (input)="onFilter($event)"
                   (focus)="onInputFocus($event)" (blur)="onInputBlur()"
                   role="combobox" aria-expanded="false"
                   aria-owns="" aria-haspopup="false">
        </div>
    </div>

    <spinner class="ng-spinner-zone" *ngIf="isLoading"></spinner>

    <span *ngIf="showClear() && multiple" (click)="handleClearClick($event)" class="ng-clear-zone" title="Clear all"
          aria-label="Clear all">
        <i class="dln-icon-no"></i>
    </span>
    <span *ngIf="!multiple" class="ng-open-close">
        <i *ngIf="!isOpen" (click)="open()" class="dln-icon-arrow_down"></i>
        <i *ngIf="isOpen" (click)="close()" class="dln-icon-arrow_up"></i>
    </span>
</div>

<div class="ng-menu-outer" [ngClass]="suggestionPosition">
    <div class="ng-menu" *ngIf="showNoItemsFound()">
        <div class="ng-option disabled">
            {{notFoundText}} <span *ngIf="addTag">(Press enter to add)</span>
        </div>
    </div>

    <div class="ng-menu" *ngIf="showTypeToSearch()">
        <div class="ng-option disabled">
            {{typeToSearchText}}
        </div>
    </div>
    <virtual-scroll role="listbox" class="ng-menu" [bufferAmount]="4" [items]="itemsList.filteredItems"
                    [filterItemSelected]="filterItemSelected"
                    (update)="viewPortItems = $event">
        <div class="ng-option" role="option" (click)="toggle(item)" (mousedown)="$event.preventDefault()"
             (mouseover)="onItemHover(item)"
             *ngFor="let item of viewPortItems"
             [class.selected]="item.selected"
             [class.item-parent]="item.isParent"
             [style.display]="item.isParent ? 'block' : (item.disabled ? 'none' : displayItem)"
             [class.hidden]="item.isParent && !isParentHasVisibleItem(item.id)"
             [class.marked]="item === itemsList.markedItem">

            <ng-template #defaultOptionTemplate>
                <div class="item-container">{{item[bindLabel]}}</div>
            </ng-template>

            <ng-template
                [ngTemplateOutlet]="item.isParent ? defaultOptionTemplate : optionTemplate || defaultOptionTemplate"
                [ngTemplateOutletContext]="{ item: item, index: item.index }">
            </ng-template>
        </div>
        <ng-template #defaultAddTagTemplate></ng-template>
    </virtual-scroll>

    <ng-template
        [ngTemplateOutlet]="addTagTemplate || defaultAddTagTemplate"
        [ngTemplateOutletContext]="{ addTagText: addTagText, filterValue: filterValue }">
    </ng-template>
</div>
